import { type CoreInquiry } from '@flecto/types'

import { type ItemCart } from '../types/ItemCart'

function isClient() {
  return typeof window !== 'undefined'
}

export function useStoreLocalStorage() {
  function getStoreDomain() {
    if (!isClient()) {
      return
    }

    return localStorage?.getItem('store-domain') ?? ''
  }

  function setStoreDomain(domain?: string) {
    if (!isClient() || typeof domain === 'undefined') {
      return
    }

    localStorage?.setItem('store-domain', String(domain))
  }

  function setBasketItems(items: ItemCart[]) {
    if (!isClient()) {
      return
    }

    localStorage?.setItem(
      `store-${getStoreDomain()}-basket-items`,
      JSON.stringify(items)
    )
  }

  function getBasketItems() {
    if (!isClient()) {
      return []
    }

    return JSON.parse(
      localStorage?.getItem(`store-${getStoreDomain()}-basket-items`) ?? '[]'
    )
  }

  function setDatesStartAt(startAt?: string) {
    if (!isClient() || !startAt) {
      return
    }

    localStorage?.setItem(`store-${getStoreDomain()}-dates-start-at`, startAt)
  }

  function setDatesEndAt(endAt?: string) {
    if (!isClient() || !endAt) {
      return
    }

    localStorage?.setItem(`store-${getStoreDomain()}-dates-end-at`, endAt)
  }

  function getDatesStartAt() {
    if (!isClient()) {
      return ''
    }

    return (
      localStorage?.getItem(`store-${getStoreDomain()}-dates-start-at`) ?? ''
    )
  }

  function getDatesEndAt() {
    if (!isClient()) {
      return ''
    }

    return localStorage?.getItem(`store-${getStoreDomain()}-dates-end-at`) ?? ''
  }

  function setOrderConfirmed(order?: CoreInquiry) {
    if (!isClient() || !order) {
      return
    }

    localStorage?.setItem(
      `store-${getStoreDomain()}-order-confirmed`,
      JSON.stringify(order)
    )
  }

  function getOrderConfirmed() {
    if (!isClient()) {
      return undefined
    }

    return JSON.parse(
      localStorage?.getItem(`store-${getStoreDomain()}-order-confirmed`) ??
        'null'
    )
  }

  return {
    getStoreDomain,
    setStoreDomain,
    setBasketItems,
    getBasketItems,
    setDatesStartAt,
    setDatesEndAt,
    getDatesStartAt,
    getDatesEndAt,
    setOrderConfirmed,
    getOrderConfirmed,
  }
}
